import { cn } from "@/lib/utils";

interface UnizenLogoProps {
  className?: string;
}

export function UnizenLogo({ className }: UnizenLogoProps) {
  return (
    <img
      src="/unizen.png"
      alt="UNIZEN"
      className={cn("object-contain", className)}
    />
  );
}
